
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired248"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired248"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c5HCY", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $8cd7cb2f9c6c5d38$export$6503ec6e8aabbaf; }, function (v) { return $8cd7cb2f9c6c5d38$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $8cd7cb2f9c6c5d38$export$f7ad0328861e2f03; }, function (v) { return $8cd7cb2f9c6c5d38$export$f7ad0328861e2f03 = v; });
var $8cd7cb2f9c6c5d38$export$6503ec6e8aabbaf;
var $8cd7cb2f9c6c5d38$export$f7ad0328861e2f03;
"use strict";
var $8cd7cb2f9c6c5d38$var$mapping = new Map();
function $8cd7cb2f9c6c5d38$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$8cd7cb2f9c6c5d38$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $8cd7cb2f9c6c5d38$var$resolve(id) {
    var resolved = $8cd7cb2f9c6c5d38$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$8cd7cb2f9c6c5d38$export$6503ec6e8aabbaf = $8cd7cb2f9c6c5d38$var$register;
$8cd7cb2f9c6c5d38$export$f7ad0328861e2f03 = $8cd7cb2f9c6c5d38$var$resolve;

});

var $c777a59a926a8b2d$exports = {};

(parcelRequire("c5HCY")).register(new URL("", import.meta.url).toString(), JSON.parse('["efcEh","index.ec06b74d.js","7krzU","exports.fc980879.js","9lCrG","w3m-modal.142f1f90.js","cORe1","dist.192f38c9.js","iL8IJ","dist.cf27de7a.js","aomoW","secp256k1.0f99aaf8.js","gMrdW","ccip.57ff8e58.js","8VB34","dist.22b0f95f.js","kfD8V","dist.0b098fd7.js","eCW61","dist.3b8eef51.js"]'));


//# sourceMappingURL=index.runtime.5111354a.js.map
